<template>
  <div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%;"
        v-loading="listLoading"
        size="default"
        border
    >
      <el-table-column property="createTime" label="消费时间"></el-table-column>
      <el-table-column property="numberNo" label="消费单号"></el-table-column>
      <el-table-column property="shopName" label="支付门店"></el-table-column>
      <el-table-column property="" label="客户信息">
        <template #default="scope">
          <p>主人：{{scope.row.userName}}</p>
          <p>手机：{{scope.row.phone}}</p>
        </template>
      </el-table-column>
      <el-table-column property="" label="宠物信息">
        <template #default="scope">
          <p v-for="item in scope.row.petList">{{item.petBreedColorName}}（{{item.name}}）</p>
        </template>
      </el-table-column>
      <el-table-column property="content" label="支付记录"></el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {getDetailShopPageList} from "@/api/url";

export default {
  name: "paymentNumDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 10,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      paymentForm: this.value.paymentForm,
      type: this.value.type,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['type'] = this.type;
      param['shopId'] = this.paymentForm.shopId;
      param['statDate'] = this.paymentForm.statDate;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getDetailShopPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },
  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
